import { observer } from 'mobx-react';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthStore from '../../store/AuthStore';
import { Button, Card, CardContent, Drawer, IconButton, Stack } from '@mui/material';
import { NewLeadDrawer } from '../../components/NewLeadDrawer';
import { LeadersListReactQuery } from '../../components/LeadersList/LeadersListReactQuery';
import { ActionsMenu } from './ActionsMenu';
import { LeadDetails } from '../../components/LeadDetails';
import { AppNavbar } from '../../components/AppNavbar';
import UserStore from '../../store/UserStore';
import { PipelinesMenu } from '../../components/PipelinesMenu';
import LeadStore from '../../store/LeadStore';
import LoadingProgressStore from '../../store/LoadingProgressStore';
import { ArrowBack } from '@mui/icons-material';
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import './styles.css';
import { isEmpty } from '../../utils/helper';

const defaultTheme = createTheme({
  typography: {
    button: {
      textTransform: 'none',
    },
  },
});

const CustomButton = styled(Button)({
  backgroundColor: '#F07B0E',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#d67e2d',
  },
  width: 'fit-content',
  height: '34px',
});

const CustomBackButton = styled(Button)({
  width: 'fit-content',
  height: '34px',
});

const SubNavBarCard = styled(Card)({
  top: '49px',
  position: 'fixed',
  width: '-webkit-fill-available',
  zIndex: '10',
  height: '45px',
  minHeight: '45px',
});

export const Home = observer(() => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const leadId = queryParams.get('leadId');
  const pipelineId = queryParams.get('pId');

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleSelectedRowChange = (leadIds) => {
    setSelectedLeads(leadIds.map((item) => parseInt(item)));
  };

  const handleShowLeadDetails = (lead) => {
    if (lead) {
      queryParams.set('leadId', lead.id);
    } else {
      queryParams.delete('leadId');
    }
    navigate({ search: queryParams.toString() });
  };

  const handleSelectedPipelineChanged = (pipeline) => {
    if (pipeline) {
      queryParams.set('pId', pipeline.id);
    } else {
      queryParams.delete('pId');
    }
    navigate({ search: queryParams.toString() });
  };

  useEffect(() => {
    if (pipelineId) {
      LeadStore.getWorkflowStatusByPipeLineId(pipelineId);
    }
  }, [pipelineId]);

  useEffect(() => {
    LoadingProgressStore.toggleIsLoading(true);
    LeadStore.getPriorities();
    UserStore.fetchUserImage();
    LeadStore.getPipelines();
  }, []);

  useEffect(() => {
    if (LeadStore.getPipelinesSuccess) {
      LoadingProgressStore.toggleIsLoading(false);
      LeadStore.getPipelines();
    }
  }, [LeadStore.getPipelinesSuccess]);

  return (
    <Card>
      <AppNavbar></AppNavbar>
      <Box sx={{ boxShadow: 'unset', overflow: 'auto' }}>
        <Stack direction="column">
          <SubNavBarCard>
            <CardContent sx={{ pt: '6px !important', pb: '6px !important' }}>
              <Stack justifyContent="space-between" direction="row" spacing={2}>
                <Stack justifyContent="flex-end" direction="row" spacing={2}>
                  {leadId ? (
                    <IconButton aria-label="back" size="small" onClick={() => handleShowLeadDetails(null)}>
                      <ArrowBack />
                    </IconButton>
                  ) : (
                    <PipelinesMenu
                      defaultPipeline={pipelineId}
                      handleSelectedPipelineChanged={handleSelectedPipelineChanged}
                    ></PipelinesMenu>
                  )}
                  <Button
                    onClick={toggleDrawer}
                    variant="contained"
                    endIcon={<ControlPointOutlinedIcon />}
                    sx={{ textTransform: 'none' }}
                  >
                    Create Lead
                  </Button>
                </Stack>
                <Stack justifyContent="flex-end" direction="row" spacing={2}>
                  <ActionsMenu
                    selectedPipeline={pipelineId}
                    toggleLeadDetails={leadId}
                    selectedLeads={selectedLeads}
                  ></ActionsMenu>
                </Stack>
              </Stack>
            </CardContent>
          </SubNavBarCard>
          <Box
            flexGrow={1}
            sx={{
              display: `${leadId === null ? 'block' : 'none'}`,
              top: '95px',
              position: 'absolute',
              width: '-webkit-fill-available',
              p: '25px',
              boxShadow: 'unset',
              backgroundColor: '#ecf0f4',
            }}
          >
            <LeadersListReactQuery
              selectedPipeline={pipelineId}
              handleSelectedRowChange={handleSelectedRowChange}
              toggleLeadDetails={handleShowLeadDetails}
            ></LeadersListReactQuery>
          </Box>
          {leadId !== null ? (
            <Box
              flexGrow={1}
              sx={{
                top: '95px',
                position: 'absolute',
                height: '-webkit-fill-available',
                overflowY: 'auto',
                width: '-webkit-fill-available',
                p: '25px',
                boxShadow: 'unset',
                backgroundColor: '#ecf0f4',
              }}
            >
              <LeadDetails ></LeadDetails>
            </Box>
          ) : (
            ''
          )}
        </Stack>
      </Box>
      <NewLeadDrawer open={drawerOpen} toggleDrawer={toggleDrawer}></NewLeadDrawer>
    </Card>
  );
});
